import { Injectable } from '@angular/core';
import { FeatureFlagAccessBySchool, FeatureFlagCodes } from '@core/models';
import { CurrentUserState } from '@core/state/shared';
import { EMPTY, forkJoin, map, Observable } from 'rxjs';
import { FeatureFlagsAccessService } from '../account';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagStatusService {
  public schoolFeatureFlag: FeatureFlagAccessBySchool;

  constructor(
    private featureFlagsAccessService: FeatureFlagsAccessService,
    private currentUserState: CurrentUserState
  ) {}

  public fetchFeatureFlag(code: FeatureFlagCodes) {
    const schoolIds = this.currentUserState.currentUserStudentsSchools
      ?.filter((school) => school !== undefined)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      .filter((id): id is string => id !== undefined);

    if (!schoolIds || schoolIds.length === 0) {
      return EMPTY;
    }
    return this.checkFeatureFlagStatusBySchool(code, schoolIds).pipe(
      map((result: FeatureFlagAccessBySchool) => {
        this.schoolFeatureFlag = result;
      })
    );
  }

  public isFeatureFlagActiveForSchool(schoolIds: string | string[]): boolean {
    const ids = Array.isArray(schoolIds) ? schoolIds : [schoolIds];
    return ids.every((schoolId) =>
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      this.schoolFeatureFlag[schoolId]?.access.every(
        (access) => access.status === 'active'
      )
    );
  }

  private checkFeatureFlagStatusBySchool(
    code: FeatureFlagCodes,
    schoolIds: string[]
  ): Observable<FeatureFlagAccessBySchool> {
    const observers = schoolIds.map((schoolId) =>
      this.featureFlagsAccessService.checkStatus(code, schoolId).pipe(
        map((result) => {
          return { schoolId, result };
        })
      )
    );
    return forkJoin(observers).pipe(
      map((results) =>
        results.reduce((acc, { schoolId, result }) => {
          acc[schoolId] = result;
          return acc;
        }, {} as FeatureFlagAccessBySchool)
      )
    );
  }
}
